export default "__VITE_ASSET__bf204b79__"